import classNames from 'classnames';
import React, { type FC } from 'react';

import { motion } from 'framer-motion';
import {
    CLUBBED_SECTION_MARGIN_TOP_IN_PX,
    COLLAPSED_SECTION_ANIMATION_DURATION_MS,
} from '../constants';
import styles from './AccordionPanel.module.scss';
import CollapsibleContainer from './CollapsibleContainer/CollapsibleContainer';
import Header from './Header/Header';

type AccordionPanelProps = {
    children: React.ReactNode;
    className?: string;
    collapsibleContainerClassName?: string;
    displayDateTime?: string;
    error?: boolean;
    errorText?: string;
    icon: React.ReactNode;
    isAppRebrandActive: boolean;
    isExpanded: boolean;
    onClick: () => void;
    shouldClubAccordionDateAndTimeSections?: boolean;
    title: string;
    sessionMinPrice?: string;
};

export const AccordionPanel: FC<AccordionPanelProps> = ({
    children,
    className,
    collapsibleContainerClassName,
    displayDateTime,
    error,
    errorText,
    icon,
    isAppRebrandActive,
    isExpanded,
    onClick,
    shouldClubAccordionDateAndTimeSections = false,
    title,
    sessionMinPrice,
}) => {
    const marginTop = shouldClubAccordionDateAndTimeSections
        ? CLUBBED_SECTION_MARGIN_TOP_IN_PX
        : 0;
    const flexShrink = isExpanded ? 1 : 0;

    return (
        <motion.div
            className={classNames(
                styles.accordionContainer,
                {
                    [styles.clubbedAccordionContainer]:
                        shouldClubAccordionDateAndTimeSections,
                },
                className,
            )}
            initial={{
                marginTop,
                flexShrink,
            }}
            animate={{
                marginTop,
                flexShrink,
            }}
            transition={{
                duration: COLLAPSED_SECTION_ANIMATION_DURATION_MS / 1000, // convert to seconds
                ease: 'easeInOut',
            }}
        >
            <Header
                error={error}
                errorText={errorText}
                icon={icon}
                isAppRebrandActive={isAppRebrandActive}
                isExpanded={isExpanded}
                onClick={onClick}
                text={displayDateTime ?? ''}
                title={title}
                sessionMinPrice={sessionMinPrice}
            />
            <CollapsibleContainer
                isExpanded={isExpanded}
                className={collapsibleContainerClassName}
            >
                {children}
            </CollapsibleContainer>
        </motion.div>
    );
};
